import once from 'lodash/function/once';

import soundcloud from '../soundcloud';

const soundcloudLoader = once(soundcloud);

/**
 * Loads SoundCloud library
 */
// eslint-disable-next-line import/prefer-default-export
export const loadSoundCloudLibrary = () => {
  try {
    soundcloudLoader();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
